export default {
  GET_USER_DETAIL: {
    url: '/user/detail/',
    method: 'GET'
  },
  UPDATE_USER_INFO: {
    url: '/user/update/',
    method: 'PUT'
  },
  RESET_USER_PASSWORD: {
    url: '/user/reset-password/',
    method: 'PUT'
  },
  CHANGE_USER_PASSWORD: {
    url: '/user/change-password',
    method: 'PUT'
  },
  FORGOT_PASSWORD: {
    url: '/auth/forgot-password',
    method: 'PUT'
  },
  CHANGE_USER_EMAIL: {
    url: '/user/change-email/',
    method: 'PUT'
  }
};
